import React from 'react'
import { FlowInner, FlowOuter } from './flow.styled'
import { useStepComponent, useStepLayoutComponent } from './flow.utils'
import useConfig from '../../../config/state/use-config'
import StepLayout from '../step-layout/step-layout'

const Flow = React.memo(() => {
  const config = useConfig()

  const StepComponent = useStepComponent()
  const StepLayoutComponent = useStepLayoutComponent()

  return config.isEmbedded ? (
    <FlowOuter>
      <FlowInner>
        <StepLayoutComponent>
          <StepComponent />
        </StepLayoutComponent>
      </FlowInner>
    </FlowOuter>
  ) : (
    <StepLayout.Root>
      <StepLayoutComponent>
        <StepComponent />
      </StepLayoutComponent>
    </StepLayout.Root>
  )
})

Flow.displayName = 'FlowComponent'

export default Flow
